import React, { useCallback, useEffect, useReducer } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import WpInput from "../../components/WriteProject/WpInput/WpInput";
import { RootState } from "../../reducers";
import "../../components/WriteProject/WpInput/WpInput";
import { PopupChange } from "../../reducers/config";
import { InsertCouponChange } from "../../reducers/data";
import "./css/index.css";
import { CouponState } from "../../interface/initialState";
import { Couponreducer } from "../../interface/ActionReducer";
import { CouponUserState } from "../../interface/interface";
import { officeApi } from "../../api/config";
import CouponUserList from "../../components/CouponUserList/CouponUserList";

function WriteCoupon() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ListData = useSelector<RootState, CouponUserState[]>(
    (state) => state.data.insertCoupon
  );
  const [{ title, period, percent, type }, patch] = useReducer(
    Couponreducer,
    CouponState
  );
  const __searchUser = useCallback(() => {
    dispatch(
      PopupChange({
        active: true,
        type: "coupon",
        content: "coupon",
      })
    );
  }, [dispatch]);
  const SpliceUser = useCallback(
    (index: number) => {
      const clone = ListData.slice();
      clone.splice(index, 1);
      dispatch(InsertCouponChange(clone));
    },
    [ListData, dispatch]
  );

  const Valid = useCallback(() => {
    return title && period && percent && ListData.length > 0 ? true : false;
  }, [title, period, percent, ListData]);

  const MakeCoupon = useCallback(() => {
    if (Valid()) {
      const usr_lst = ListData.map((item) => {
        return {
          usr_id: item.usr_id,
        };
      });
      officeApi
        .post(`/cstm/cpon`, {
          cpon_nm: title,
          cpon_discnt_rate: percent,
          cpon_type_cd: "normal",
          cpon_ctg_cd: type,
          cpon_apply_en_at: new Date(period),
          usr_lst,
        })
        .then(({ data: { sts_fg } }) => {
          if (sts_fg) {
            navigate("/etc/coupon");
          }
        });
    }
    // navigate(-1);
  }, [navigate, title, period, percent, type, Valid, ListData]);

  const UpdateCommon = useCallback(
    (type: string, payload: string | number) => {
      patch({
        type: `coupon/${type}`,
        payload,
        index: undefined,
      });
    },
    [patch]
  );
  useEffect(() => {
    dispatch(InsertCouponChange([]));
    return () => {};
  }, [dispatch]);

  return (
    <main className="coupon-insert-page">
      <div className="wrapper">
        <div className="title">쿠폰 발급</div>
        <div className="coupon-write-section">
          <div className="coupon-write-content">
            <WpInput
              title="쿠폰명"
              placeholder="쿠폰명을 입력해주세요"
              initial={title}
              max={26}
              type="text"
              reg={"title"}
              __update={UpdateCommon}
              error={undefined}
            />
            <WpInput
              title="사용기한"
              placeholder="YYYY-MM-DD"
              initial={period}
              max={10}
              type="text"
              reg={"finish"}
              __update={UpdateCommon}
              error={undefined}
            />
            <WpInput
              title="할인율"
              placeholder="할인율을 입력해주세요"
              initial={percent}
              max={undefined}
              type="number"
              reg={"percent"}
              __update={UpdateCommon}
              error={undefined}
            />
            <div className="coupon-select-category">
              <div className="title">카테고리</div>
              <div className="coupon-category-list">
                {select_category_layout.map(({ title, category }, idx) => {
                  return (
                    <button
                      className={`coupon-category-btn ${
                        category === type ? "active-btn" : ""
                      }`}
                      key={idx}
                      onClick={() => {
                        UpdateCommon("type", category);
                      }}
                    >
                      {title}
                    </button>
                  );
                })}
              </div>
            </div>
            <div className="coupon-user-select" onClick={__searchUser}>
              <div className="title">발급 대상 검색</div>
              <div className="box">
                발급 대상 검색
                <img
                  src="/assets/project/right-arrow.svg"
                  className="img"
                  alt="이동"
                ></img>
              </div>
            </div>
          </div>
          <div className="title">선택된 발급대상</div>
          <CouponUserList ListData={ListData} SpliceUser={SpliceUser} />
          <div
            className={`bluebox ${Valid() ? "active-box" : ""}`}
            onClick={() => {
              if (Valid()) {
                MakeCoupon();
              }
            }}
          >
            쿠폰 발급
          </div>
        </div>
      </div>
    </main>
  );
}

export default WriteCoupon;

const select_category_layout = [
  {
    category: "prjt",
    title: "프로젝트",
  },
  {
    category: "mtup",
    title: "밋업",
  },
];
